'use client'
import Image from 'next/image.js';

import { sprinkles } from '@/style/landingPage/theme.css';
import * as styles from '@/style/landingPage/styles.css';

import selfyImg from '../../../public/images/landingPage/photos/banner/selfy.jpg';
import bakingImg from '../../../public/images/landingPage/photos/banner/baking.jpg';
import layingOnCouchImg from '../../../public/images/landingPage/photos/banner/laying-on-couch.jpg';
import familyManImg from '../../../public/images/landingPage/photos/banner/family-man.jpg';
import womanWorkingImg from '../../../public/images/landingPage/photos/banner/woman-working.jpg';
import photographerImg from '../../../public/images/landingPage/photos/banner/photographer.jpg';
import kidsOnGameConsoleImg from '../../../public/images/landingPage/photos/banner/kids-on-game-console.jpg';
import ladyUsingMobileImg from '../../../public/images/landingPage/photos/banner/lady-using-mobile.jpg';
import outdoorPhotographyImg from '../../../public/images/landingPage/photos/banner/outdoor-photography.jpg';
import ladyUsingPhoneImg from '../../../public/images/landingPage/photos/banner/lady-using-phone.jpg';
import laundryImg from '../../../public/images/landingPage/photos/banner/laundry.jpg';
import virtualRealityImg from '../../../public/images/landingPage/photos/banner/virtual-reality.jpg';

export default function DesktopBanner() {
  return (
    <section id='banner'>
      <div id='banner-grid'>
        <header className="top-middle-rows">
          <aside className='overlay-animation ending-animation'>
            <Image priority loading="eager" 
              src={selfyImg}
              alt="Selfy."
              placeholder="blur"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </aside>
          <aside className='overlay-animation ending-animation'>
            <Image priority loading="eager" 
              src={bakingImg}
              alt="Baking."
              placeholder="blur"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
          </aside>
        </header>
        <aside className="left-column">
          <div className="aside-column-content">
              <Image priority loading="eager" 
                src={layingOnCouchImg}
                alt="Laying on the couch."
                placeholder="blur"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
          </div>
          <div className="aside-column-content">
            <Image priority loading="eager" 
              src={familyManImg}
              alt="Family man."
              placeholder="blur"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>
          <div className="aside-column-content overlay-animation_NON starting-animation">
            <Image priority loading="eager" 
              src={womanWorkingImg}
              alt="Working woman."
              placeholder="blur"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>
          <div className="aside-column-content overlay-animation_NON starting-animation">
            {/* Image size is inconsistent */}
              <Image priority loading="eager" 
                src={photographerImg}
                alt="Photographer."
                placeholder="blur"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
          </div>
          <div className="aside-column-content overlay-animation_NON starting-animation">
            {/* Image size is inconsistent */}
            <Image priority loading="eager" 
              src={kidsOnGameConsoleImg}
              alt="Kids on game console."
              placeholder="blur"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>
          <div className="aside-column-content overlay-animation_NON starting-animation">
            {/* Image size is inconsistent */}
              <Image priority loading="eager" 
                src={ladyUsingMobileImg}
                alt="Lady using mobile."
                placeholder="blur"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
          </div>
        </aside>
        <section className="banner-content">
          <div className={sprinkles({ color: 'white', gap: 'lg', display: 'flex', height: 'full', justifyContent: 'center',  alignItems: 'center', flexDirection: 'column'})}
          >
            <header className="overlay-animation heading-animation">
              <h1 className={styles.mainHeading}>Device ownership <div className={sprinkles({ color: 'aqua',})}>reimagined</div></h1>
              <p className={`
                  ${sprinkles({
                    fontSize: {
                      mobile: 'md',
                      tablet: 'md',
                      desktop: 'md',
                      largeScreens: 'lg'
                    }
                  })}
                  ${{
                    fontWeight: '400',
                    lineHeight: 1.6,
                  }}
                `
              }>Kingfisher is now SquareTrade, delivering <br />leading mobile and protection services across  <br />the world</p>
            </header>
            <div className="overlay-animation button-animation">
              <a href="#intro-section"
                className={sprinkles({ backgroundColor: 'orange', color: 'navy', display: 'flex', alignItems: 'center', justifyContent: 'center' })}
                  style={{
                    border: 'none',
                    borderRadius: '50%',
                    width: '56px',
                    height: '56px',
                    cursor: 'pointer',
                  }}
                >
                  <svg width="11" height="11" viewBox="0 0 11 11" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.1875 -7.43313e-07L6.1875 8.36687L10.0306 4.52375L11 5.5L5.5 11L7.13262e-07 5.5L0.969375 4.53062L4.8125 8.36687L4.8125 -6.8321e-07L6.1875 -7.43313e-07Z" fill="#0E1942"/>
                  </svg>
              </a>
              </div>
          </div>
        </section>
        <aside className="right-column">
          <div className="aside-column-content">
            {/* Image size is inconsistent */}
            <Image priority loading="eager" 
              src={kidsOnGameConsoleImg}
              alt="Kids on game console."
              placeholder="blur"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>
          <div className="aside-column-content">
            {/* Image size is inconsistent */}
            <Image priority loading="eager" 
              src={ladyUsingMobileImg}
              alt="Lady using mobile."
              placeholder="blur"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>
          <div className="aside-column-content overlay-animation_NON starting-animation">
            {/* Image size is inconsistent */}
            <Image priority loading="eager" 
              src={outdoorPhotographyImg}
              alt="Outdoor photography."
              placeholder="blur"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>
          <div className="aside-column-content overlay-animation_NON starting-animation">
              {/* Image size is inconsistent */}
            <Image priority loading="eager" 
              src={ladyUsingPhoneImg}
              alt="Lady using phone."
              placeholder="blur"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>
          <div className="aside-column-content overlay-animation_NON starting-animation">
            <Image priority loading="eager" 
              src={layingOnCouchImg}
              alt="Laying on the couch."
              placeholder="blur"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>
          <div className="aside-column-content overlay-animation_NON starting-animation">
            <Image priority loading="eager" 
              src={familyManImg}
              alt="Family man."
              placeholder="blur"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>
        </aside>
        <footer className="bottom-middle-rows">
          <div className="bottom-column-content overlay-animation_NON starting-animation">
            <Image priority loading="eager"
              src={laundryImg}
              alt="Laundry."
              placeholder="blur"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>
          <div className="bottom-column-content overlay-animation_NON starting-animation">
            <Image priority loading="eager"
              src={virtualRealityImg}
              alt="Virtual reality."
              placeholder="blur"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>
          <div className="bottom-column-content overlay-animation_NON starting-animation">
            <Image priority loading="eager" 
              src={layingOnCouchImg}
              alt="Laying on the couch."
              placeholder="blur"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />

          </div>
          <div className="bottom-column-content overlay-animation_NON starting-animation">
            <Image priority loading="eager" 
              src={familyManImg}
              alt="Family man."
              placeholder="blur"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>
          <div className="bottom-column-content overlay-animation_NON starting-animation">
            <Image priority loading="eager"
              src={virtualRealityImg}
              alt="Virtual reality."
              placeholder="blur"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>
          <div className="bottom-column-content overlay-animation_NON starting-animation">
            <Image priority loading="eager" 
              src={photographerImg}
              alt="Photographer."
              placeholder="blur"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>
          <div className="bottom-column-content overlay-animation_NON starting-animation">
            <Image priority loading="eager" 
              src={ladyUsingPhoneImg}
              alt="Lady using phone."
              placeholder="blur"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>
          <div className="bottom-column-content overlay-animation_NON starting-animation">
            <Image priority loading="eager" 
              src={outdoorPhotographyImg}
              alt="Outdoor photography."
              placeholder="blur"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>
        </footer>
      </div>
    </section>
  )
}
